export default __webpack_public_path__ + "static/media/rakhi3.0181ee4b.jpeg";